export default __webpack_public_path__ + "static/media/websitevideos_3.73619be7.png";